import { GymMember, Student } from "../types/wizard-demo.types";

export const gymMembers: GymMember[] = [
  {
    firstName: "Sarah",
    fullName: "Sarah Chen",
    initials: "SC",
    avatar: "https://randomuser.me/api/portraits/women/24.jpg",
  },
  {
    firstName: "Tim",
    fullName: "Tim Williams",
    initials: "TW",
    avatar: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    firstName: "Alex",
    fullName: "Alex Rodriguez",
    initials: "AR",
    avatar: "https://randomuser.me/api/portraits/men/47.jpg",
  },
  {
    firstName: "Emma",
    fullName: "Emma Williams",
    initials: "EW",
    avatar: "https://randomuser.me/api/portraits/women/17.jpg",
  },
  {
    firstName: "Emiton",
    fullName: "Emiton Alverson",
    initials: "EA",
    avatar: "https://randomuser.me/api/portraits/men/7.jpg",
  },
  {
    firstName: "Jessica",
    fullName: "Jessica Brown",
    initials: "JB",
    avatar: "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    firstName: "Nolan",
    fullName: "Nolan Parks",
    initials: "NP",
    avatar: "https://randomuser.me/api/portraits/men/41.jpg",
  },
  {
    firstName: "Daniel",
    fullName: "Daniel Holler",
    initials: "DH",
    avatar: "https://randomuser.me/api/portraits/men/85.jpg",
  },
  {
    firstName: "Brian",
    fullName: "Brian Edwards",
    initials: "BE",
    avatar: "https://randomuser.me/api/portraits/men/76.jpg",
  },
  {
    firstName: "Casey",
    fullName: "Casey Thompson",
    initials: "CT",
    avatar: "https://randomuser.me/api/portraits/women/33.jpg",
  },
];


export const students: Student[] = [
  {
    id: "1",
    name: "Sarah Chen",
    initials: "SC",
    currentBelt: {
      name: "Purple Belt",
      color: "#8B5CF6",
      degree: "1st Degree",
    },
    progress: 25,
    classesAtRank: 89,
    nextBelt: { name: "Purple Belt", color: "#8B5CF6", degree: "2nd Degree" },
    avatar: "https://randomuser.me/api/portraits/women/24.jpg",
  },
  {
    id: "2",
    name: "Tim Williams",
    initials: "TW",
    currentBelt: {
      name: "Blue Belt",
      color: "#3B82F6",
      degree: "4th Degree",
    },
    progress: 78,
    classesAtRank: 156,
    nextBelt: { name: "Purple Belt", color: "#8B5CF6" },
    avatar: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    id: "3",
    name: "Alex Rodriguez",
    initials: "AR",
    currentBelt: {
      name: "Blue Belt",
      color: "#3B82F6",
      degree: "3rd Degree",
    },
    progress: 45,
    classesAtRank: 67,
    nextBelt: { name: "Blue Belt", color: "#3B82F6", degree: "4th Degree" },
    avatar: "https://randomuser.me/api/portraits/men/47.jpg",
  },
  {
    id: "4",
    name: "Emma Williams",
    initials: "EW",
    currentBelt: {
      name: "Blue Belt",
      color: "#3B82F6",
      degree: "2nd Degree",
    },
    progress: 62,
    classesAtRank: 98,
    nextBelt: { name: "Blue Belt", color: "#3B82F6", degree: "3rd Degree" },
    avatar: "https://randomuser.me/api/portraits/women/17.jpg",
  },
  {
    id: "5",
    name: "Emiton Alverson",
    initials: "EA",
    currentBelt: {
      name: "Blue Belt",
      color: "#3B82F6",
      degree: "1st Degree",
    },
    progress: 33,
    classesAtRank: 52,
    nextBelt: { name: "Blue Belt", color: "#3B82F6", degree: "2nd Degree" },
    avatar: "https://randomuser.me/api/portraits/men/7.jpg",
  },
  {
    id: "6",
    name: "Jessica Brown",
    initials: "JB",
    currentBelt: { name: "Blue Belt", color: "#3B82F6" },
    progress: 85,
    classesAtRank: 127,
    nextBelt: { name: "Blue Belt", color: "#3B82F6", degree: "1st Degree" },
    avatar: "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    id: "7",
    name: "Nolan Parks",
    initials: "NP",
    currentBelt: { name: "Blue Belt", color: "#3B82F6" },
    progress: 92,
    classesAtRank: 114,
    nextBelt: { name: "Blue Belt", color: "#3B82F6", degree: "1st Degree" },
    avatar: "https://randomuser.me/api/portraits/men/41.jpg",
  },
  {
    id: "8",
    name: "Daniel Holler",
    initials: "DH",
    currentBelt: {
      name: "White Belt",
      color: "#FFFFFF",
      degree: "3rd Degree",
    },
    progress: 71,
    classesAtRank: 58,
    nextBelt: { name: "White Belt", color: "#FFFFFF", degree: "4th Degree" },
    avatar: "https://randomuser.me/api/portraits/men/85.jpg",
  },
  {
    id: "9",
    name: "Brian Edwards",
    initials: "BE",
    currentBelt: {
      name: "White Belt",
      color: "#FFFFFF",
      degree: "2nd Degree",
    },
    progress: 44,
    classesAtRank: 31,
    nextBelt: { name: "White Belt", color: "#FFFFFF", degree: "3rd Degree" },
    avatar: "https://randomuser.me/api/portraits/men/76.jpg",
  },
  {
    id: "10",
    name: "Casey Thompson",
    initials: "CT",
    currentBelt: {
      name: "White Belt",
      color: "#FFFFFF",
    },
    progress: 18,
    classesAtRank: 12,
    nextBelt: { name: "White Belt", color: "#FFFFFF", degree: "1st Degree" },
    avatar: "https://randomuser.me/api/portraits/women/33.jpg",
  },
];
